import { sendGet } from "./generic"


export const getPolicyNumbersRemaining = ()=>{
    return sendGet("PolicyNumbers/Remaining")
}
